export enum WhoopProStatus {
    ACTIVE = 'active',
    EXPIRING = 'expiring',
    INACTIVE = 'inactive',
    INELIGIBLE = 'ineligible'
}